import { not } from './boolean.no-deps'
import { compose } from './compose.no-deps'

export const isPostive = (num: number) => num >= 0
export const isEven = (num: number) => num % 2 === 0
export const isFinite = (num: number) => Number.isFinite(num)
export const isInteger = (num: number) => Number.isInteger(num)
export const isNaN = (num: number) => Number.isNaN(num)

export const isNegative = compose(isPostive, not)
export const isOdd = compose(isEven, not)
export const isNotFinite = compose(isFinite, not)
export const isNotInteger = compose(isInteger, not)
export const isNotNaN = compose(isNaN, not)

export const sum = (a: number, b: number) => a + b
export const product = (a: number, b: number) => a * b
